<template>
  <div class="min-h-full">
    <Calendar
      :loading="loading"
      :tasks="tasks"
      :campaigns="campaigns"
      :production-orders="productionOrders"
      @update-calendar="fetchData"
    />

    <portal v-if="$route.query.editCampaign" to="app-modal">
      <CampaignModal :campaign-id="$route.query.editCampaign" />
    </portal>

    <portal v-if="$route.query.editProductionOrderItemId" to="app-modal">
      <OrderItemModal
        :order-item-id="$route.query.editProductionOrderItemId"
        @order-item-modal:closed="productionOrderItemModalClosed"
      />
    </portal>

    <portal v-if="$route.query.editTaskId" to="app-modal">
      <TaskModal :task-id="$route.query.editTaskId" @task-modal:closed="taskModalClosed" />
    </portal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Calendar from '@/components/Calendar/Calendar.vue';
import CampaignModal from '@/components/Campaigns/CampaignModal.vue';
import OrderItemModal from '@/components/OrderItems/OrderItemModal.vue';
import TaskModal from '@/components/Tasks/TaskModal.vue';

export default {
  components: {
    Calendar,
    CampaignModal,
    OrderItemModal,
    TaskModal,
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapGetters('ui/campaigns', ['campaigns']),
    ...mapGetters('ui/tasks', ['tasks']),
    ...mapGetters('ui/productionOrders', ['productionOrders']),
  },

  beforeRouteLeave(to, from, next) {
    this.setCampaignIds([]);
    this.setTaskIds([]);
    next();
  },

  methods: {
    ...mapActions('ui/campaigns', {
      loadCampaigns: 'getCampaigns',
    }),
    ...mapActions('ui/tasks', {
      loadTasks: 'load',
    }),
    ...mapActions('ui/productionOrders', {
      loadProductionOrders: 'load',
    }),

    ...mapMutations('ui/campaigns', {
      setCampaignIds: 'setIds',
    }),
    ...mapMutations('ui/tasks', {
      setTaskIds: 'setIds',
    }),
    ...mapMutations('ui/productionOrders', {
      setProductionOrderIds: 'setIds',
    }),

    async fetchData(options) {
      this.loading = true;

      try {
        await Promise.all([
          this.loadCampaigns({
            params: {
              filter: {
                starts_or_ends_between: options.period,
                dates_visible_on_calendar: 'both,start,end',
              },
              limit: 200,
            },
          }),
          this.loadTasks({
            params: {
              filter: {
                due_between: options.period,
                has_project: true,
              },
              include: 'contact,contactRequest,project.client,orderItem,userAssigned',
              sort: 'due_at',
              limit: 200,
            },
          }),
          this.loadProductionOrders({
            params: {
              filter: {
                delivery_between: options.period,
              },
              include: 'orderItems,project,provider',
              limit: 200,
            },
          }),
        ]);
      } catch (error) {
        //
      }

      this.loading = false;
    },

    taskModalClosed() {
      this.$router.push({
        name: this.$route.name,
        query: {
          taskId: this.$route.query.taskId,
        },
      });
    },

    productionOrderItemModalClosed() {
      this.$router.push({
        name: this.$route.name,
        query: {
          productionOrderItemId: this.$route.query.productionOrderItemId,
        },
      });
    },
  },
};
</script>
